import { inject, Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IUserLicense } from '../../../interfaces/licenses/IUserLicense';
import { IUserLicenseTool } from '../../../interfaces/licenses/IUserLicenseTool';

@Injectable({
  providedIn: 'root',
})
export class UserLicenseService {
  private http: HttpClient = inject(HttpClient);
  private API_URL: string = environment.services.urlEDI;

  constructor() {}

  loadUserLicense(): Observable<IUserLicense> {
    return this.http.get<IUserLicense>(`${this.API_URL}/user_license`);
  }

  getAvailableTool(userTools: IUserLicenseTool[] | null | undefined, toolName: string): boolean {
  if (!userTools?.length) return false;
  return userTools.find(t => t.tool_name === toolName)?.available ?? false;
  }
}
